/*import React, { useState, useEffect } from 'react';
import { Trophy, Medal, Award, Zap, Target, ArrowRight, Star, ShieldCheck, Activity, Timer, CalendarDays, Megaphone, MapPin, Building2, Gift, FileBadge, Phone } from 'lucide-react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { db } from '../serices/firebase'; 
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import Footer from '../components/Footer';
import SponsorStrip from '../components/SponsorStrip';

const Home = () => {
  const { scrollY } = useScroll();
  const trophyY = useTransform(scrollY, [0, 1000], [0, -200]);
  const medalY = useTransform(scrollY, [0, 1000], [0, -400]);

  const [nomineeCount, setNomineeCount] = useState(0);

  // --- COUNTDOWN LOGIC (Targeting May 25th) ---
  const votingDeadline = new Date("2026-11-01T00:00:00").getTime();
  const [timeLeft, setTimeLeft] = useState({ days: 14, hours: 0, minutes: 0, seconds: 0 });

  const venueInfo = {
    name: "THE AVID HOTEL",
    logo: "https://res.cloudinary.com/djazx3hkx/image/upload/v1776166770/uojmdlstwogf8ds72xyy.jpg",
    location: "Voi, Taita Taveta"
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = votingDeadline - now;

      if (distance < 0) {
        clearInterval(interval);
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [votingDeadline]);

  // Fetch Dynamic Approved Nominees Count
  useEffect(() => {
    const q = query(collection(db, "nominations"), where("status", "==", "approved"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setNomineeCount(snapshot.size);
    });
    return () => unsubscribe();
  }, []);

  const officialSupport = {
  phone: "+254 736 546 311 / +254 724 562 555",
  name: "Mzinyi Marketing & Support"
};

const accolades = [
  { title: "Grand Trophy", desc: "The 2026 Crystal Peak of Excellence.", icon: <Trophy size={24}/> },
  { title: "Official Certification", desc: "Signed endorsement of regional talent.", icon: <FileBadge size={24}/> },
  { title: "Surprise Gift", desc: "A curated reward revealed at the Gala.", icon: <Gift size={24}/> }
];

  return (
    <div className="bg-[#050505] text-white min-h-screen relative overflow-hidden font-sans">
      
      {/* --- LAYER 0: FILM GRAIN TEXTURE --- *//*
      <div className="fixed inset-0 pointer-events-none z-[99] opacity-[0.03] bg-[url('https://res.cloudinary.com/dcbofid78/image/upload/v1710925413/noise_vfs6vv.png')]" />

      {/* --- LAYER 1: DYNAMIC BACKGROUND --- *//*
      <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden">
        <motion.div style={{ y: trophyY }} className="absolute -top-20 -right-20 text-[#D4AF37]/10 blur-[1px]">
          <Trophy size={700} strokeWidth={0.5} />
        </motion.div>
        <motion.div style={{ y: medalY }} className="absolute top-[40%] -left-32 text-[#D4AF37]/5 blur-[2px]">
          <Medal size={800} strokeWidth={0.3} />
        </motion.div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[800px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#D4AF37]/10 via-transparent to-transparent opacity-60" />
      </div>

      {/* --- HERO SECTION --- *//*
      <section className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-6 py-20">
        
        {/* --- NEW: PUBLIC DEMAND NOMINATION ALERT --- *//*
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12 inline-flex items-center gap-4 bg-[#D4AF37] text-black px-6 py-3 rounded-full shadow-[0_0_30px_rgba(212,175,55,0.3)] animate-bounce"
        >
          <Megaphone size={18} />
          <span className="text-[11px] font-black uppercase tracking-wider italic">
             Nominations are open!
          </span>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 40 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1.5, ease: [0.16, 1, 0.3, 1] }}
        >
          {/* LIVE STATUS LABEL *//*
          <div className="flex flex-col items-center gap-4 mb-8">
            <div className="flex items-center justify-center gap-4">
              <div className="h-[1px] w-8 bg-green-500/50" />
              <span className="flex items-center gap-2 text-green-500 text-[10px] font-black tracking-[0.6em] uppercase animate-pulse">
                 <Activity size={12} /> Nominations are Officially open
              </span>
              <div className="h-[1px] w-8 bg-green-500/50" />
            </div>
            
            <div className="flex items-center gap-2 text-[#D4AF37] bg-[#D4AF37]/10 px-4 py-1.5 rounded-full border border-[#D4AF37]/20">
              <CalendarDays size={14} />
              <span className="text-[10px] font-black uppercase tracking-widest italic">The Grand Gala Night • May 30th, 2026</span>
            </div>
          </div>

          <h1 className="text-6xl md:text-[140px] font-black tracking-tighter mb-8 uppercase italic leading-[0.8] relative">
            <span className="block text-white drop-shadow-2xl">MZINYI</span>
            <span className="bg-gradient-to-b from-[#D4AF37] via-[#F7E0A1] to-[#D4AF37] bg-clip-text text-transparent italic relative">TAITA TAVETA AWARDS</span>
          </h1>

          <p className="max-w-2xl mt-10 mx-auto text-white/40 text-xs md:text-sm tracking-[0.4em] uppercase mb-12 font-bold leading-relaxed italic px-6">
            The portal is open. Nominate your favorite talent or cast your vote to define the <span className="text-white">Legends</span> of Taita Taveta.
          </p>

          {/* --- VOTING DEADLINE COUNTDOWN --- *//*
          <div className="flex flex-col items-center mb-16">
            <div className="flex items-center gap-3 mb-6 text-white/40">
              <Timer size={16} />
              <span className="text-[10px] font-black tracking-[0.4em] uppercase italic">Nomination Portal Closes In:</span>
            </div>
            
            <div className="flex gap-4 md:gap-8 mb-10">
              {[
                { label: 'Days', val: timeLeft.days },
                { label: 'Hrs', val: timeLeft.hours },
                { label: 'Min', val: timeLeft.minutes },
                { label: 'Sec', val: timeLeft.seconds },
              ].map((item, i) => (
                <div key={i} className="flex flex-col items-center bg-white/[0.03] border border-white/5 px-4 py-2 rounded-xl min-w-[60px] md:min-w-[80px]">
                  <div className="text-2xl md:text-4xl font-black text-white tracking-tighter tabular-nums leading-none">
                    {String(item.val).padStart(2, '0')}
                  </div>
                  <div className="text-[7px] md:text-[8px] font-black text-[#D4AF37] uppercase tracking-[0.2em] mt-1">
                    {item.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white/5 border border-white/10 px-8 py-4 rounded-2xl backdrop-blur-xl">
                 <p className="text-[#D4AF37] text-xl md:text-2xl font-black uppercase italic tracking-tighter tabular-nums leading-none">
                    {nomineeCount} <span className="text-white/40 text-xs not-italic tracking-widest ml-2 uppercase">Approved Nominees</span>
                 </p>
            </div>
          </div>

          {/* --- ACTION BUTTONS (NOMINATE IS NOW SECONDARY BUT BOLD) --- *//*
          <div className="flex flex-col md:flex-row gap-8 justify-center items-center">
            <Link to="/categories">
              <button className="group relative bg-[#D4AF37] text-black px-14 py-6 font-black tracking-[0.3em] uppercase overflow-hidden transition-all duration-500 hover:bg-white shadow-[0_20px_50px_-10px_rgba(212,175,55,0.4)]">
                <span className="relative z-10 flex items-center gap-3">Start Voting Now <ArrowRight size={18} /></span>
                <motion.div className="absolute inset-0 bg-white/20 -translate-x-full skew-x-12 group-hover:translate-x-full transition-transform duration-1000" />
              </button>
            </Link>
            
            <Link to="/nominate">
              <button className="group border-2 border-[#D4AF37] text-[#D4AF37] px-14 py-6 font-black tracking-[0.3em] uppercase transition-all duration-500 hover:bg-[#D4AF37] hover:text-black shadow-[0_0_20px_rgba(212,175,55,0.1)]">
                Nominate
              </button>
            </Link>
          </div>
        </motion.div>
      </section>

      {/* --- STATS BAR --- *//*
      <div className="relative z-10 grid grid-cols-2 md:grid-cols-4 border-y border-white/5 bg-white/[0.02] backdrop-blur-2xl">
        {[
          ["Categories", "22", <Trophy size={16}/>], 
          ["Nominees", `${nomineeCount}`, <Star size={16}/>], 
          ["Voting End Date", "Dec 01", <Timer size={16}/>], 
          ["Event Night", "Dec 05", <Award size={16}/>]
        ].map(([label, val, icon], i) => (
          <motion.div 
            key={label} 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            className="py-16 text-center border-r border-white/5 last:border-0 group hover:bg-[#D4AF37]/5 transition-all duration-700"
          >
            <div className="flex justify-center text-[#D4AF37]/40 group-hover:text-[#D4AF37] mb-4 transition-colors">
              {icon}
            </div>
            <h3 className="text-4xl font-black text-white group-hover:scale-110 transition-transform duration-500">{val}</h3>
            <p className="text-[9px] uppercase tracking-[0.3em] text-white/30 font-bold mt-3">{label}</p>
          </motion.div>
        ))}
      </div>

      {/* --- LUXURY VENUE SPOTLIGHT --- *//*
<section className="relative z-10 py-6 px-6">
  <div className="max-w-4xl mx-auto bg-gradient-to-br from-zinc-900/50 to-black border border-[#D4AF37]/20 p-8 md:p-16 rounded-[3rem] backdrop-blur-md relative overflow-hidden group">
      {/* Background Decorative Icon *//*
      <Building2 className="absolute -bottom-10 -right-10 text-[#D4AF37]/5" size={300} />
      
      <div className="flex flex-col md:flex-row items-center gap-12 relative z-10">
          {/* Venue Logo Box *//*
          <div className="w-48 h-48 bg-black rounded-3xl border border-white/10 p-6 flex items-center justify-center shadow-2xl group-hover:border-[#D4AF37]/50 transition-all duration-700">
              <img src={venueInfo.logo} alt="Venue Logo" className="max-h-full max-w-full object-contain" />
          </div>
          
          {/* Venue Info *//*
          <div className="text-center md:text-left flex-1">
              <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.5em] mb-4 italic">Official Venue Partner</p>
              <h2 className="text-4xl md:text-6xl font-black uppercase italic tracking-tighter text-white mb-6 leading-none">{venueInfo.name}</h2>
              <div className="flex items-center justify-center md:justify-start gap-3 text-white/40">
                  <MapPin size={18} className="text-[#D4AF37]" />
                  <span className="text-sm font-bold uppercase tracking-widest">{venueInfo.location}</span>
              </div>
              <div className="mt-10 h-[1px] w-full bg-gradient-to-r from-[#D4AF37]/40 to-transparent" />
              <p className="mt-6 text-[9px] font-black uppercase tracking-[0.3em] text-white/20 italic">Hosting the most prestigious night in Taita Taveta</p>
          </div>
      </div>
  </div>
</section>

{/* --- THE WINNER'S ACCOLADES --- *//*
<section className="relative z-10 py-24 px-6 border-y border-white/5 bg-white/[0.01]">
  <div className="max-w-7xl mx-auto text-center">
      <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.5em] mb-12 italic">At Stake for the Legends</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {accolades.map((item, i) => (
              <motion.div 
                  key={i}
                  whileHover={{ y: -10 }}
                  className="p-10 rounded-[2.5rem] bg-zinc-900/40 border border-white/5 backdrop-blur-sm group"
              >
                  <div className="text-[#D4AF37] mb-6 flex justify-center group-hover:scale-110 transition-transform duration-500">{item.icon}</div>
                  <h4 className="text-sm font-black uppercase tracking-widest mb-3">{item.title}</h4>
                  <p className="text-white/40 text-xs leading-relaxed font-bold uppercase italic">{item.desc}</p>
              </motion.div>
          ))}
      </div>
  </div>
</section>

      <section className="relative z-10 py-6 px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-32 items-center">
          <div className="relative">
            <motion.div style={{ rotate: scrollY }} className="absolute -top-24 -left-20 opacity-[0.03] text-[#D4AF37] -z-10">
              <Award size={400} strokeWidth={0.5} />
            </motion.div>
            <h2 className="text-6xl font-black tracking-tighter leading-[0.85] mb-10 uppercase italic">Your Vote <br /> <span className="text-[#D4AF37]">Powering</span> <br /> The Next Legend.</h2>
            <div className="space-y-8">
              <p className="text-white/60 font-light text-2xl italic leading-relaxed border-l-[3px] border-[#D4AF37] pl-10 py-2 italic">
                "The Mzinyi Taita Taveta Awards represent the pulse of our culture. Every vote is an investment into our region's creative future."
              </p>
              
              <div className="flex items-center gap-6 ml-10 pt-4">
                 <ShieldCheck className="text-[#D4AF37]" size={32} />
                 <div>
                    <p className="text-[10px] font-black tracking-[0.3em] uppercase text-[#D4AF37] mb-1">Technology Partner</p>
                    <p className="text-xs font-bold text-white/60 uppercase">Powered by <span className="text-white">Inicus Innovations Limited</span></p>
                 </div>
                 {/* OFFICIAL SUPPORT LINE *//*
<div className="flex items-center gap-6 ml-10 pt-4">
   <div className="bg-[#D4AF37] p-3 rounded-2xl text-black">
      <Phone size={24} />
   </div>
   <div>
      <p className="text-[10px] font-black tracking-[0.3em] uppercase text-[#D4AF37] mb-1">Official Inquiries</p>
      <p className="text-sm font-black text-white italic tracking-widest">{officialSupport.phone}</p>
   </div>
</div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6">
            {[
              { title: "Instant STK Payments", desc: "Secure M-Pesa checkouts powered by Inicus Innovations.", icon: <Zap size={20} /> },
              { title: "Public Audit Trail", desc: "Total transparency. Every vote is logged and verifiable live.", icon: <Target size={20} /> },
              { title: "VIP Gala Access", desc: "Top contributors and voters join the elite list for the gala night.", icon: <Trophy size={20} /> }
            ].map((item, i) => (
              <motion.div key={i} whileHover={{ x: 15, backgroundColor: "rgba(255,255,255,0.04)" }} className="bg-white/[0.02] border border-white/10 p-10 rounded-2xl group transition-all duration-500">
                <div className="flex items-start gap-8">
                  <div className="text-[#D4AF37] bg-[#D4AF37]/10 p-3 rounded-lg group-hover:bg-[#D4AF37] group-hover:text-black transition-all duration-500">{item.icon}</div>
                  <div>
                    <h4 className="text-sm font-black tracking-[0.2em] uppercase mb-3">{item.title}</h4>
                    <p className="text-white/40 text-[13px] leading-relaxed font-medium">{item.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <div className="relative z-10 py-10 bg-black/40 border-t border-white/5">
        <SponsorStrip />
      </div>
      <Footer/>
    </div>
  );
};

export default Home;*/



import React, { useState, useEffect } from 'react';
import { Trophy, Medal, Award, Zap, Target, ArrowRight, Star, ShieldCheck, Activity, Timer, CalendarDays, Megaphone, MapPin, Building2, Gift, FileBadge, Phone } from 'lucide-react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { db } from '../serices/firebase'; 
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import Footer from '../components/Footer';
import SponsorStrip from '../components/SponsorStrip';

import { NOMINATION_DEADLINE, VOTING_END, getEventPhase } from '../utils/eventDates';

const Home = () => {
  const { scrollY } = useScroll();
  const trophyY = useTransform(scrollY, [0, 1000], [0, -200]);
  const medalY = useTransform(scrollY, [0, 1000], [0, -400]);

  const [nomineeCount, setNomineeCount] = useState(0);
  const [phase, setPhase] = useState(getEventPhase);

  // --- COUNTDOWN LOGIC ---
  // While nominations are open, count down to the nomination deadline.
  // Once voting has started, count down to the voting close date instead.
  const countdownTarget = phase === 'nominating' ? NOMINATION_DEADLINE : VOTING_END;
  const countdownLabel = phase === 'nominating' ? 'Nomination Portal Closes In:' : 'Voting Closes In:';

  const calculateTimeLeft = (target) => {
    const distance = target - new Date().getTime();
    if (distance < 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    return {
      days: Math.floor(distance / (1000 * 60 * 60 * 24)),
      hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((distance % (1000 * 60)) / 1000),
    };
  };

  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(countdownTarget));

  const venueInfo = {
    name: "THE AVID HOTEL",
    logo: "https://res.cloudinary.com/djazx3hkx/image/upload/v1776166770/uojmdlstwogf8ds72xyy.jpg",
    location: "Voi, Taita Taveta"
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentPhase = getEventPhase();
      setPhase(currentPhase);

      const target = currentPhase === 'nominating' ? NOMINATION_DEADLINE : VOTING_END;
      setTimeLeft(calculateTimeLeft(target));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Fetch Dynamic Approved Nominees Count
  useEffect(() => {
    const q = query(collection(db, "nominations"), where("status", "==", "approved"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setNomineeCount(snapshot.size);
    });
    return () => unsubscribe();
  }, []);

  const officialSupport = {
  phone: "+254 736 546 311 / +254 724 562 555",
  name: "Mzinyi Marketing & Support"
};

const accolades = [
  { title: "Grand Trophy", desc: "The 2026 Crystal Peak of Excellence.", icon: <Trophy size={24}/> },
  { title: "Official Certification", desc: "Signed endorsement of regional talent.", icon: <FileBadge size={24}/> },
  { title: "Surprise Gift", desc: "A curated reward revealed at the Gala.", icon: <Gift size={24}/> }
];

  return (
    <div className="bg-[#050505] text-white min-h-screen relative overflow-hidden font-sans">
      
      {/* --- LAYER 0: FILM GRAIN TEXTURE --- */}
      <div className="fixed inset-0 pointer-events-none z-[99] opacity-[0.03] bg-[url('https://res.cloudinary.com/dcbofid78/image/upload/v1710925413/noise_vfs6vv.png')]" />

      {/* --- LAYER 1: DYNAMIC BACKGROUND --- */}
      <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden">
        <motion.div style={{ y: trophyY }} className="absolute -top-20 -right-20 text-[#D4AF37]/10 blur-[1px]">
          <Trophy size={700} strokeWidth={0.5} />
        </motion.div>
        <motion.div style={{ y: medalY }} className="absolute top-[40%] -left-32 text-[#D4AF37]/5 blur-[2px]">
          <Medal size={800} strokeWidth={0.3} />
        </motion.div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[800px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#D4AF37]/10 via-transparent to-transparent opacity-60" />
      </div>

      {/* --- HERO SECTION --- */}
      <section className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-6 py-20">
        
        {/* --- NEW: PUBLIC DEMAND NOMINATION ALERT --- */}
        {/*<motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12 inline-flex items-center gap-4 bg-[#D4AF37] text-black px-6 py-3 rounded-full shadow-[0_0_30px_rgba(212,175,55,0.3)] animate-bounce"
         >
          <Megaphone size={18} />
          <span className="text-[11px] font-black uppercase tracking-wider italic">
             Nominations are open!
          </span>
        </motion.div>*/}

        <motion.div 
          initial={{ opacity: 0, y: 40 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1.5, ease: [0.16, 1, 0.3, 1] }}
        >
          {/* LIVE STATUS LABEL */}
          <div className="flex flex-col items-center gap-4 mb-8">
            {/*<div className="flex items-center justify-center gap-4">
              <div className="h-[1px] w-8 bg-green-500/50" />
              <span className="flex items-center gap-2 text-green-500 text-[10px] font-black tracking-[0.6em] uppercase animate-pulse">
                 <Activity size={12} /> Nominations are Officially open
              </span>
              <div className="h-[1px] w-8 bg-green-500/50" />
            </div>*/}
            
            <div className="flex items-center gap-2 text-[#D4AF37] bg-[#D4AF37]/10 px-4 py-1.5 rounded-full border border-[#D4AF37]/20">
              <CalendarDays size={14} />
              <span className="text-[10px] font-black uppercase tracking-widest italic">The Grand Gala Night • December 5th, 2026</span>
            </div>
          </div>

          {/*<h1 className="text-6xl md:text-[140px] font-black tracking-tighter mb-8 uppercase italic leading-[0.8] relative">
            <span className="block text-white drop-shadow-2xl">MZINYI</span>
            <span className="bg-gradient-to-b from-[#D4AF37] via-[#F7E0A1] to-[#D4AF37] bg-clip-text text-transparent italic relative">TAITA TAVETA AWARDS</span>
            <span className="block text-white drop-shadow-xl">SEASON 2</span>
          </h1>*/}
          <h1 className="text-6xl md:text-[140px] font-black tracking-tighter mb-4 uppercase italic leading-[0.8] relative">
  <span className="block text-white drop-shadow-2xl">MZINYI</span>
  <span className="bg-gradient-to-b from-[#D4AF37] via-[#F7E0A1] to-[#D4AF37] bg-clip-text text-transparent italic relative">TAITA TAVETA AWARDS</span>
</h1>

<div className="flex items-center justify-center gap-4 md:gap-6 mb-8">
  <div className="h-[1px] w-10 md:w-20 bg-[#D4AF37]/40" />
  <span className="text-[#D4AF37] text-lg md:text-2xl font-black uppercase italic tracking-[0.4em]">Season 2</span>
  <div className="h-[1px] w-10 md:w-20 bg-[#D4AF37]/40" />
</div>

          <p className="max-w-2xl mt-10 mx-auto text-white/40 text-xs md:text-sm tracking-[0.4em] uppercase mb-12 font-bold leading-relaxed italic px-6">
            The portal is open. Nominate your favorite talent or cast your vote to define the <span className="text-white">Legends</span> of Taita Taveta.
          </p>

          {/* --- VOTING DEADLINE COUNTDOWN --- */}
          <div className="flex flex-col items-center mb-16">
            <div className="flex items-center gap-3 mb-6 text-white/40">
              <Timer size={16} />
              <span className="text-[10px] font-black tracking-[0.4em] uppercase italic">{countdownLabel}</span>
            </div>
            
            <div className="flex gap-4 md:gap-8 mb-10">
              {[
                { label: 'Days', val: timeLeft.days },
                { label: 'Hrs', val: timeLeft.hours },
                { label: 'Min', val: timeLeft.minutes },
                { label: 'Sec', val: timeLeft.seconds },
              ].map((item, i) => (
                <div key={i} className="flex flex-col items-center bg-white/[0.03] border border-white/5 px-4 py-2 rounded-xl min-w-[60px] md:min-w-[80px]">
                  <div className="text-2xl md:text-4xl font-black text-white tracking-tighter tabular-nums leading-none">
                    {String(item.val).padStart(2, '0')}
                  </div>
                  <div className="text-[7px] md:text-[8px] font-black text-[#D4AF37] uppercase tracking-[0.2em] mt-1">
                    {item.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white/5 border border-white/10 px-8 py-4 rounded-2xl backdrop-blur-xl">
                 <p className="text-[#D4AF37] text-xl md:text-2xl font-black uppercase italic tracking-tighter tabular-nums leading-none">
                    {nomineeCount} <span className="text-white/40 text-xs not-italic tracking-widest ml-2 uppercase">Approved Nominees</span>
                 </p>
            </div>
          </div>

          {/* --- ACTION BUTTONS (only the active phase's action is clickable) --- */}
          <div className="flex flex-col md:flex-row gap-8 justify-center items-center">
            {phase === 'voting' || phase === 'closed' ? (
              <Link to="/categories">
                <button className="group relative bg-[#D4AF37] text-black px-14 py-6 font-black tracking-[0.3em] uppercase overflow-hidden transition-all duration-500 hover:bg-white shadow-[0_20px_50px_-10px_rgba(212,175,55,0.4)]">
                  <span className="relative z-10 flex items-center gap-3">Start Voting Now <ArrowRight size={18} /></span>
                  <motion.div className="absolute inset-0 bg-white/20 -translate-x-full skew-x-12 group-hover:translate-x-full transition-transform duration-1000" />
                </button>
              </Link>
            ) : (
              <button disabled className="bg-white/5 text-white/20 px-14 py-6 font-black tracking-[0.3em] uppercase cursor-not-allowed border border-white/5">
                Voting Opens Oct 26
              </button>
            )}

            {phase === 'nominating' ? (
              <Link to="/nominate">
                <button className="group border-2 border-[#D4AF37] text-[#D4AF37] px-14 py-6 font-black tracking-[0.3em] uppercase transition-all duration-500 hover:bg-[#D4AF37] hover:text-black shadow-[0_0_20px_rgba(212,175,55,0.1)]">
                  Nominate
                </button>
              </Link>
            ) : (
              <button disabled className="border-2 border-white/5 text-white/20 px-14 py-6 font-black tracking-[0.3em] uppercase cursor-not-allowed">
                Nominations Closed
              </button>
            )}
          </div>
        </motion.div>
      </section>

      {/* --- STATS BAR --- */}
      <div className="relative z-10 grid grid-cols-2 md:grid-cols-4 border-y border-white/5 bg-white/[0.02] backdrop-blur-2xl">
        {[
          ["Categories", "22", <Trophy size={16}/>], 
          ["Nominees", `${nomineeCount}`, <Star size={16}/>], 
          ["Voting End Date", "Nov 30", <Timer size={16}/>], 
          ["Event Night", "Dec 05", <Award size={16}/>]
        ].map(([label, val, icon], i) => (
          <motion.div 
            key={label} 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            className="py-16 text-center border-r border-white/5 last:border-0 group hover:bg-[#D4AF37]/5 transition-all duration-700"
          >
            <div className="flex justify-center text-[#D4AF37]/40 group-hover:text-[#D4AF37] mb-4 transition-colors">
              {icon}
            </div>
            <h3 className="text-4xl font-black text-white group-hover:scale-110 transition-transform duration-500">{val}</h3>
            <p className="text-[9px] uppercase tracking-[0.3em] text-white/30 font-bold mt-3">{label}</p>
          </motion.div>
        ))}
      </div>

      {/* --- LUXURY VENUE SPOTLIGHT --- */}
{/*<section className="relative z-10 py-6 px-6">
  <div className="max-w-4xl mx-auto bg-gradient-to-br from-zinc-900/50 to-black border border-[#D4AF37]/20 p-8 md:p-16 rounded-[3rem] backdrop-blur-md relative overflow-hidden group">
      {/* Background Decorative Icon *//*
      <Building2 className="absolute -bottom-10 -right-10 text-[#D4AF37]/5" size={300} />
      
      <div className="flex flex-col md:flex-row items-center gap-12 relative z-10">
          {/* Venue Logo Box *//*
          <div className="w-48 h-48 bg-black rounded-3xl border border-white/10 p-6 flex items-center justify-center shadow-2xl group-hover:border-[#D4AF37]/50 transition-all duration-700">
              <img src={venueInfo.logo} alt="Venue Logo" className="max-h-full max-w-full object-contain" />
          </div>
          
          {/* Venue Info *//*
          <div className="text-center md:text-left flex-1">
              <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.5em] mb-4 italic">Official Venue Partner</p>
              <h2 className="text-4xl md:text-6xl font-black uppercase italic tracking-tighter text-white mb-6 leading-none">{venueInfo.name}</h2>
              <div className="flex items-center justify-center md:justify-start gap-3 text-white/40">
                  <MapPin size={18} className="text-[#D4AF37]" />
                  <span className="text-sm font-bold uppercase tracking-widest">{venueInfo.location}</span>
              </div>
              <div className="mt-10 h-[1px] w-full bg-gradient-to-r from-[#D4AF37]/40 to-transparent" />
              <p className="mt-6 text-[9px] font-black uppercase tracking-[0.3em] text-white/20 italic">Hosting the most prestigious night in Taita Taveta</p>
          </div>
      </div>
  </div>
</section>*/}

{/* --- THE WINNER'S ACCOLADES --- */}
<section className="relative z-10 py-24 px-6 border-y border-white/5 bg-white/[0.01]">
  <div className="max-w-7xl mx-auto text-center">
      <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.5em] mb-12 italic">At Stake for the Legends</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {accolades.map((item, i) => (
              <motion.div 
                  key={i}
                  whileHover={{ y: -10 }}
                  className="p-10 rounded-[2.5rem] bg-zinc-900/40 border border-white/5 backdrop-blur-sm group"
              >
                  <div className="text-[#D4AF37] mb-6 flex justify-center group-hover:scale-110 transition-transform duration-500">{item.icon}</div>
                  <h4 className="text-sm font-black uppercase tracking-widest mb-3">{item.title}</h4>
                  <p className="text-white/40 text-xs leading-relaxed font-bold uppercase italic">{item.desc}</p>
              </motion.div>
          ))}
      </div>
  </div>
</section>

      <section className="relative z-10 py-6 px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-32 items-center">
          <div className="relative">
            <motion.div style={{ rotate: scrollY }} className="absolute -top-24 -left-20 opacity-[0.03] text-[#D4AF37] -z-10">
              <Award size={400} strokeWidth={0.5} />
            </motion.div>
            <h2 className="text-6xl font-black tracking-tighter leading-[0.85] mb-10 uppercase italic">Your Vote <br /> <span className="text-[#D4AF37]">Powering</span> <br /> The Next Legend.</h2>
            <div className="space-y-8">
              <p className="text-white/60 font-light text-2xl italic leading-relaxed border-l-[3px] border-[#D4AF37] pl-10 py-2 italic">
                "The Mzinyi Taita Taveta Awards represent the pulse of our culture. Every vote is an investment into our region's creative future."
              </p>
              
              <div className="flex items-center gap-6 ml-10 pt-4">
                 <ShieldCheck className="text-[#D4AF37]" size={32} />
                 <div>
                    <p className="text-[10px] font-black tracking-[0.3em] uppercase text-[#D4AF37] mb-1">Technology Partner</p>
                    <p className="text-xs font-bold text-white/60 uppercase">Powered by <span className="text-white">Inicus Innovations Limited</span></p>
                 </div>
                 {/* OFFICIAL SUPPORT LINE */}
<div className="flex items-center gap-6 ml-10 pt-4">
   <div className="bg-[#D4AF37] p-3 rounded-2xl text-black">
      <Phone size={24} />
   </div>
   <div>
      <p className="text-[10px] font-black tracking-[0.3em] uppercase text-[#D4AF37] mb-1">Official Inquiries</p>
      <p className="text-sm font-black text-white italic tracking-widest">{officialSupport.phone}</p>
   </div>
</div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6">
            {[
              { title: "Instant STK Payments", desc: "Secure M-Pesa checkouts powered by Inicus Innovations.", icon: <Zap size={20} /> },
              { title: "Public Audit Trail", desc: "Total transparency. Every vote is logged and verifiable live.", icon: <Target size={20} /> },
              { title: "VIP Gala Access", desc: "Top contributors and voters join the elite list for the gala night.", icon: <Trophy size={20} /> }
            ].map((item, i) => (
              <motion.div key={i} whileHover={{ x: 15, backgroundColor: "rgba(255,255,255,0.04)" }} className="bg-white/[0.02] border border-white/10 p-10 rounded-2xl group transition-all duration-500">
                <div className="flex items-start gap-8">
                  <div className="text-[#D4AF37] bg-[#D4AF37]/10 p-3 rounded-lg group-hover:bg-[#D4AF37] group-hover:text-black transition-all duration-500">{item.icon}</div>
                  <div>
                    <h4 className="text-sm font-black tracking-[0.2em] uppercase mb-3">{item.title}</h4>
                    <p className="text-white/40 text-[13px] leading-relaxed font-medium">{item.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <div className="relative z-10 py-10 bg-black/40 border-t border-white/5">
        <SponsorStrip />
      </div>
      <Footer/>
    </div>
  );
};

export default Home;















/*import React, { useState, useEffect } from 'react';
import { Trophy, Medal, Award, Zap, Target, ArrowRight, Star, ShieldCheck, Activity, Timer, CalendarDays } from 'lucide-react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { db } from '../serices/firebase'; 
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import Footer from '../components/Footer';
import SponsorStrip from '../components/SponsorStrip';

const Home = () => {
  const { scrollY } = useScroll();
  const trophyY = useTransform(scrollY, [0, 1000], [0, -200]);
  const medalY = useTransform(scrollY, [0, 1000], [0, -400]);

  const [nomineeCount, setNomineeCount] = useState(0);

  // --- COUNTDOWN LOGIC (Targeting May 25th) ---
  const votingDeadline = new Date("2026-05-25T00:00:00").getTime();
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = votingDeadline - now;

      if (distance < 0) {
        clearInterval(interval);
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [votingDeadline]);

  // Fetch Dynamic Approved Nominees Count
  useEffect(() => {
    const q = query(collection(db, "nominations"), where("status", "==", "approved"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setNomineeCount(snapshot.size);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="bg-[#050505] text-white min-h-screen relative overflow-hidden font-sans">
      
      {/* --- LAYER 0: FILM GRAIN TEXTURE --- *//*
      <div className="fixed inset-0 pointer-events-none z-[99] opacity-[0.03] bg-[url('https://res.cloudinary.com/dcbofid78/image/upload/v1710925413/noise_vfs6vv.png')]" />

      {/* --- LAYER 1: DYNAMIC BACKGROUND --- *//*
      <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden">
        <motion.div style={{ y: trophyY }} className="absolute -top-20 -right-20 text-[#D4AF37]/10 blur-[1px]">
          <Trophy size={700} strokeWidth={0.5} />
        </motion.div>
        <motion.div style={{ y: medalY }} className="absolute top-[40%] -left-32 text-[#D4AF37]/5 blur-[2px]">
          <Medal size={800} strokeWidth={0.3} />
        </motion.div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[800px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#D4AF37]/10 via-transparent to-transparent opacity-60" />
      </div>

      {/* --- HERO SECTION --- *//*
      <section className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-6 py-20">
        <motion.div 
          initial={{ opacity: 0, y: 40 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1.5, ease: [0.16, 1, 0.3, 1] }}
        >
          {/* LIVE STATUS LABEL *//*
          <div className="flex flex-col items-center gap-4 mb-8">
            <div className="flex items-center justify-center gap-4">
              <div className="h-[1px] w-8 bg-green-500/50" />
              <span className="flex items-center gap-2 text-green-500 text-[10px] font-black tracking-[0.6em] uppercase animate-pulse">
                 <Activity size={12} /> Voting is Officially Live
              </span>
              <div className="h-[1px] w-8 bg-green-500/50" />
            </div>
            
            {/* EVENT DATE ANNOUNCEMENT *//*
            <div className="flex items-center gap-2 text-[#D4AF37] bg-[#D4AF37]/10 px-4 py-1.5 rounded-full border border-[#D4AF37]/20">
              <CalendarDays size={14} />
              <span className="text-[10px] font-black uppercase tracking-widest italic">The Grand Gala Night • May 30th, 2026</span>
            </div>
          </div>

          {/* MAIN TITLE *//*
          <h1 className="text-6xl md:text-[140px] font-black tracking-tighter mb-8 uppercase italic leading-[0.8] relative">
            <span className="block text-white drop-shadow-2xl">MZINYI</span>
            <span className="bg-gradient-to-b from-[#D4AF37] via-[#F7E0A1] to-[#D4AF37] bg-clip-text text-transparent italic relative">TAITA TAVETA AWARDS</span>
          </h1>

          <p className="max-w-2xl mt-10 mx-auto text-white/40 text-xs md:text-sm tracking-[0.4em] uppercase mb-12 font-bold leading-relaxed italic">
            The portal is open. Your voice defines the <span className="text-white">Legends</span> of Taita Taveta.
          </p>

          {/* --- VOTING DEADLINE COUNTDOWN --- *//*
          <div className="flex flex-col items-center mb-16">
            <div className="flex items-center gap-3 mb-6 text-white/40">
              <Timer size={16} />
              <span className="text-[10px] font-black tracking-[0.4em] uppercase italic">Voting Portal Closes In:</span>
            </div>
            
            <div className="flex gap-4 md:gap-8 mb-10">
              {[
                { label: 'Days', val: timeLeft.days },
                { label: 'Hrs', val: timeLeft.hours },
                { label: 'Min', val: timeLeft.minutes },
                { label: 'Sec', val: timeLeft.seconds },
              ].map((item, i) => (
                <div key={i} className="flex flex-col items-center bg-white/[0.03] border border-white/5 px-4 py-2 rounded-xl min-w-[60px] md:min-w-[80px]">
                  <div className="text-2xl md:text-4xl font-black text-white tracking-tighter tabular-nums leading-none">
                    {String(item.val).padStart(2, '0')}
                  </div>
                  <div className="text-[7px] md:text-[8px] font-black text-[#D4AF37] uppercase tracking-[0.2em] mt-1">
                    {item.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white/5 border border-white/10 px-8 py-4 rounded-2xl backdrop-blur-xl">
                 <p className="text-[#D4AF37] text-xl md:text-2xl font-black uppercase italic tracking-tighter tabular-nums leading-none">
                    {nomineeCount} <span className="text-white/40 text-xs not-italic tracking-widest ml-2 uppercase">Approved Nominees</span>
                 </p>
            </div>
            
            <div className="mt-4 flex flex-col items-center gap-2">
                <p className="text-[9px] font-bold text-white/20 uppercase tracking-[0.4em] italic">Cast unlimited votes to support your candidate</p>
                <span className="bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20 px-3 py-1 rounded-full text-[8px] font-black uppercase tracking-widest italic">KES 10 Per Vote</span>
            </div>
          </div>

          {/* UPDATED BUTTONS *//*
          <div className="flex flex-col md:flex-row gap-8 justify-center items-center">
            <Link to="/categories">
              <button className="group relative bg-[#D4AF37] text-black px-14 py-6 font-black tracking-[0.3em] uppercase overflow-hidden transition-all duration-500 hover:bg-white shadow-[0_20px_50px_-10px_rgba(212,175,55,0.4)]">
                <span className="relative z-10 flex items-center gap-3">Start Voting Now <ArrowRight size={18} /></span>
                <motion.div className="absolute inset-0 bg-white/20 -translate-x-full skew-x-12 group-hover:translate-x-full transition-transform duration-1000" />
              </button>
            </Link>
            <Link to="/categories">
              <button className="border border-white/40 text-white px-14 py-6 font-black tracking-[0.3em] uppercase transition-all duration-500 hover:bg-white hover:text-black hover:border-white backdrop-blur-sm">
                View Nominees
              </button>
            </Link>
          </div>
        </motion.div>
      </section>

      {/* --- STATS BAR --- *//*
      <div className="relative z-10 grid grid-cols-2 md:grid-cols-4 border-y border-white/5 bg-white/[0.02] backdrop-blur-2xl">
        {[
          ["Categories", "22", <Trophy size={16}/>], 
          ["Nominees", `${nomineeCount}`, <Star size={16}/>], 
          ["Voting End Date", "May 25", <Timer size={16}/>], 
          ["Event Night", "May 30", <Award size={16}/>]
        ].map(([label, val, icon], i) => (
          <motion.div 
            key={label} 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            className="py-16 text-center border-r border-white/5 last:border-0 group hover:bg-[#D4AF37]/5 transition-all duration-700"
          >
            <div className="flex justify-center text-[#D4AF37]/40 group-hover:text-[#D4AF37] mb-4 transition-colors">
              {icon}
            </div>
            <h3 className="text-4xl font-black text-white group-hover:scale-110 transition-transform duration-500">{val}</h3>
            <p className="text-[9px] uppercase tracking-[0.3em] text-white/30 font-bold mt-3">{label}</p>
          </motion.div>
        ))}
      </div>

      {/* --- IMPACT SECTION --- *//*
      <section className="relative z-10 py-40 px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-32 items-center">
          <div className="relative">
            <motion.div style={{ rotate: scrollY }} className="absolute -top-24 -left-20 opacity-[0.03] text-[#D4AF37] -z-10">
              <Award size={400} strokeWidth={0.5} />
            </motion.div>
            <h2 className="text-6xl font-black tracking-tighter leading-[0.85] mb-10 uppercase italic">Your Vote <br /> <span className="text-[#D4AF37]">Powering</span> <br /> The Next Legend.</h2>
            <div className="space-y-8">
              <p className="text-white/60 font-light text-2xl italic leading-relaxed border-l-[3px] border-[#D4AF37] pl-10 py-2 italic">
                "The Mzinyi Taita Taveta Awards represent the pulse of our culture. Every vote is an investment into our region's creative future."
              </p>
              
              <div className="flex items-center gap-6 ml-10 pt-4">
                 <ShieldCheck className="text-[#D4AF37]" size={32} />
                 <div>
                    <p className="text-[10px] font-black tracking-[0.3em] uppercase text-[#D4AF37] mb-1">Technology Partner</p>
                    <p className="text-xs font-bold text-white/60 uppercase">Powered by <span className="text-white">Inicus Innovations Limited</span></p>
                 </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6">
            {[
              { title: "Instant STK Payments", desc: "Secure M-Pesa checkouts powered by Inicus Innovations.", icon: <Zap size={20} /> },
              { title: "Public Audit Trail", desc: "Total transparency. Every vote is logged and verifiable live.", icon: <Target size={20} /> },
              { title: "VIP Gala Access", desc: "Top contributors and voters join the elite list for the gala night.", icon: <Trophy size={20} /> }
            ].map((item, i) => (
              <motion.div key={i} whileHover={{ x: 15, backgroundColor: "rgba(255,255,255,0.04)" }} className="bg-white/[0.02] border border-white/10 p-10 rounded-2xl group transition-all duration-500">
                <div className="flex items-start gap-8">
                  <div className="text-[#D4AF37] bg-[#D4AF37]/10 p-3 rounded-lg group-hover:bg-[#D4AF37] group-hover:text-black transition-all duration-500">{item.icon}</div>
                  <div>
                    <h4 className="text-sm font-black tracking-[0.2em] uppercase mb-3">{item.title}</h4>
                    <p className="text-white/40 text-[13px] leading-relaxed font-medium">{item.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <div className="relative z-10 py-10 bg-black/40 border-t border-white/5">
        <SponsorStrip />
      </div>
      <Footer/>
    </div>
  );
};

export default Home;*/















/*import React, { useState, useEffect } from 'react';
import { Trophy, Medal, Award, Zap, Target, ArrowRight, Star, ShieldCheck, Activity } from 'lucide-react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { db } from '../serices/firebase'; 
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import Footer from '../components/Footer';
import SponsorStrip from '../components/SponsorStrip';

const Home = () => {
  const { scrollY } = useScroll();
  const trophyY = useTransform(scrollY, [0, 1000], [0, -200]);
  const medalY = useTransform(scrollY, [0, 1000], [0, -400]);

  const [nomineeCount, setNomineeCount] = useState(0);

  // Fetch Dynamic Approved Nominees Count
  useEffect(() => {
    const q = query(collection(db, "nominations"), where("status", "==", "approved"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setNomineeCount(snapshot.size);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="bg-[#050505] text-white min-h-screen relative overflow-hidden font-sans">
      
      {/* --- LAYER 0: FILM GRAIN TEXTURE --- *//*
      <div className="fixed inset-0 pointer-events-none z-[99] opacity-[0.03] bg-[url('https://res.cloudinary.com/dcbofid78/image/upload/v1710925413/noise_vfs6vv.png')]" />

      {/* --- LAYER 1: DYNAMIC BACKGROUND --- *//*
      <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden">
        <motion.div style={{ y: trophyY }} className="absolute -top-20 -right-20 text-[#D4AF37]/10 blur-[1px]">
          <Trophy size={700} strokeWidth={0.5} />
        </motion.div>
        <motion.div style={{ y: medalY }} className="absolute top-[40%] -left-32 text-[#D4AF37]/5 blur-[2px]">
          <Medal size={800} strokeWidth={0.3} />
        </motion.div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[800px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#D4AF37]/10 via-transparent to-transparent opacity-60" />
      </div>

      {/* --- HERO SECTION --- *//*
      <section className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-6 py-20">
        <motion.div 
          initial={{ opacity: 0, y: 40 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1.5, ease: [0.16, 1, 0.3, 1] }}
        >
          {/* LIVE STATUS LABEL *//*
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="h-[1px] w-12 bg-green-500/50" />
            <span className="flex items-center gap-2 text-green-500 text-[10px] font-black tracking-[0.6em] uppercase animate-pulse">
               <Activity size={12} /> Voting is Officially Live
            </span>
            <div className="h-[1px] w-12 bg-green-500/50" />
          </div>

          {/* MAIN TITLE *//*
          <h1 className="text-6xl md:text-[140px] font-black tracking-tighter mb-8 uppercase italic leading-[0.8] relative">
            <span className="block text-white drop-shadow-2xl">MZINYI</span>
            <span className="bg-gradient-to-b from-[#D4AF37] via-[#F7E0A1] to-[#D4AF37] bg-clip-text text-transparent italic relative">TAVETA AWARDS</span>
          </h1>

          <p className="max-w-2xl mt-10 mx-auto text-white/40 text-xs md:text-sm tracking-[0.4em] uppercase mb-12 font-bold leading-relaxed italic">
            The portal is open. Your voice defines the <span className="text-white">Legends</span> of Taita Taveta.
          </p>

       
          {/* --- ACTIVE STATUS AREA --- *//*
<div className="flex flex-col items-center mb-16">
  <div className="bg-white/5 border border-white/10 px-8 py-4 rounded-2xl backdrop-blur-xl">
       <p className="text-[#D4AF37] text-xl md:text-2xl font-black uppercase italic tracking-tighter tabular-nums">
          {nomineeCount} <span className="text-white/40 text-xs not-italic tracking-widest ml-2">Active Nominees</span>
       </p>
  </div>
  
  {/* PROFESSIONAL PRICING LABEL *//*
  <div className="mt-4 flex flex-col items-center gap-1">
      <p className="text-[9px] font-bold text-white/20 uppercase tracking-[0.4em] italic">
        Cast unlimited votes to support your legend
      </p>
      <span className="bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20 px-3 py-1 rounded-full text-[8px] font-black uppercase tracking-widest">
         KES 10 Per Vote
      </span>
  </div>
</div>

          {/* UPDATED BUTTONS *//*
          <div className="flex flex-col md:flex-row gap-8 justify-center items-center">
            <Link to="/categories">
              <button className="group relative bg-[#D4AF37] text-black px-14 py-6 font-black tracking-[0.3em] uppercase overflow-hidden transition-all duration-500 hover:bg-white shadow-[0_20px_50px_-10px_rgba(212,175,55,0.4)]">
                <span className="relative z-10 flex items-center gap-3">Start Voting Now <ArrowRight size={18} /></span>
                <motion.div className="absolute inset-0 bg-white/20 -translate-x-full skew-x-12 group-hover:translate-x-full transition-transform duration-1000" />
              </button>
            </Link>
            <Link to="/pulse">
              <button className="border border-white/40 text-white px-14 py-6 font-black tracking-[0.3em] uppercase transition-all duration-500 hover:bg-white hover:text-black hover:border-white backdrop-blur-sm">
                View Leaderboard
              </button>
            </Link>
          </div>
        </motion.div>
      </section>

      {/* --- GLASS STATS BAR --- *//*
      <div className="relative z-10 grid grid-cols-2 md:grid-cols-4 border-y border-white/5 bg-white/[0.02] backdrop-blur-2xl">
        {[
          ["Categories", "22", <Trophy size={16}/>], 
          ["Nominees", `${nomineeCount}`, <Star size={16}/>], 
          ["Reach", "10K+", <Target size={16}/>], 
          ["Elite Honors", "2026", <Award size={16}/>]
        ].map(([label, val, icon], i) => (
          <motion.div 
            key={label} 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            className="py-16 text-center border-r border-white/5 last:border-0 group hover:bg-[#D4AF37]/5 transition-all duration-700"
          >
            <div className="flex justify-center text-[#D4AF37]/40 group-hover:text-[#D4AF37] mb-4 transition-colors">
              {icon}
            </div>
            <h3 className="text-4xl font-black text-white group-hover:scale-110 transition-transform duration-500">{val}</h3>
            <p className="text-[9px] uppercase tracking-[0.3em] text-white/30 font-bold mt-3">{label}</p>
          </motion.div>
        ))}
      </div>

      {/* --- TRUST & IMPACT SECTION --- *//*
      <section className="relative z-10 py-40 px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-32 items-center">
          <div className="relative">
            <motion.div style={{ rotate: scrollY }} className="absolute -top-24 -left-20 opacity-[0.03] text-[#D4AF37] -z-10">
              <Award size={400} strokeWidth={0.5} />
            </motion.div>
            <h2 className="text-6xl font-black tracking-tighter leading-[0.85] mb-10 uppercase italic">Your Vote <br /> <span className="text-[#D4AF37]">Powering</span> <br /> The Next Legend.</h2>
            <div className="space-y-8">
              <p className="text-white/60 font-light text-2xl italic leading-relaxed border-l-[3px] border-[#D4AF37] pl-10 py-2 italic">
                "The Mzinyi Taita Taveta Awards represent the pulse of our culture. Every vote is an investment into our region's creative future."
              </p>
              
              <div className="flex items-center gap-6 ml-10 pt-4">
                 <ShieldCheck className="text-[#D4AF37]" size={32} />
                 <div>
                    <p className="text-[10px] font-black tracking-[0.3em] uppercase text-[#D4AF37] mb-1">Technology Partner</p>
                    <p className="text-xs font-bold text-white/60 uppercase">Powered by <span className="text-white">Inicus Innovations Limited</span></p>
                 </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6">
            {[
              { title: "Instant STK Payments", desc: "Secure M-Pesa checkouts powered by Inicus Innovations.", icon: <Zap size={20} /> },
              { title: "Public Audit Trail", desc: "Total transparency. Every vote is logged and verifiable live.", icon: <Target size={20} /> },
              { title: "VIP Gala Access", desc: "Top contributors and voters join the elite list for the gala night.", icon: <Trophy size={20} /> }
            ].map((item, i) => (
              <motion.div key={i} whileHover={{ x: 15, backgroundColor: "rgba(255,255,255,0.04)" }} className="bg-white/[0.02] border border-white/10 p-10 rounded-2xl group transition-all duration-500">
                <div className="flex items-start gap-8">
                  <div className="text-[#D4AF37] bg-[#D4AF37]/10 p-3 rounded-lg group-hover:bg-[#D4AF37] group-hover:text-black transition-all duration-500">{item.icon}</div>
                  <div>
                    <h4 className="text-sm font-black tracking-[0.2em] uppercase mb-3">{item.title}</h4>
                    <p className="text-white/40 text-[13px] leading-relaxed font-medium">{item.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <div className="relative z-10 py-10 bg-black/40 border-t border-white/5">
        <SponsorStrip />
      </div>
      <Footer/>
    </div>
  );
};

export default Home;*/
